var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "plan-feature" } }, [
    _c("div", { staticClass: "feature" }, [
      _c("div", { staticClass: "feature-title" }, [_vm._v("Support Feature")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "feature-delete",
          on: {
            click: function ($event) {
              return _vm.$emit("close")
            },
          },
        },
        [_c("span", { staticClass: "material-icons" }, [_vm._v("close")])]
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "feature-form" }, [
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Reporting")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-select",
              {
                staticStyle: { width: "100%" },
                model: {
                  value: _vm.featureForm.support,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "support", $$v)
                  },
                  expression: "featureForm.support",
                },
              },
              [
                _c("a-select-option", { attrs: { value: "basic-support" } }, [
                  _vm._v("Basic Support"),
                ]),
                _vm._v(" "),
                _c("a-select-option", { attrs: { value: "7-24-support" } }, [
                  _vm._v("24/7 Support"),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "feature-item" }, [
        _c("div", { staticClass: "feature-label" }, [_vm._v("Other Features")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "feature-input" },
          [
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.softwareSupport,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "softwareSupport", $$v)
                  },
                  expression: "featureForm.softwareSupport",
                },
              },
              [_vm._v("Software Support")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.dedicatedCustomerSupport,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "dedicatedCustomerSupport", $$v)
                  },
                  expression: "featureForm.dedicatedCustomerSupport",
                },
              },
              [_vm._v("Dedicated Customer Support")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportWhatsappBusinessSetup,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.featureForm,
                      "supportWhatsappBusinessSetup",
                      $$v
                    )
                  },
                  expression: "featureForm.supportWhatsappBusinessSetup",
                },
              },
              [_vm._v("Whatsapp Business Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportFacebookSetup,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportFacebookSetup", $$v)
                  },
                  expression: "featureForm.supportFacebookSetup",
                },
              },
              [_vm._v("Facebook Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportInstagramSetup,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportInstagramSetup", $$v)
                  },
                  expression: "featureForm.supportInstagramSetup",
                },
              },
              [_vm._v("Instagram Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportChatbotSetup,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportChatbotSetup", $$v)
                  },
                  expression: "featureForm.supportChatbotSetup",
                },
              },
              [_vm._v("Chatbot Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportAISetup,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportAISetup", $$v)
                  },
                  expression: "featureForm.supportAISetup",
                },
              },
              [_vm._v("AI Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportAutomationSetup,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportAutomationSetup", $$v)
                  },
                  expression: "featureForm.supportAutomationSetup",
                },
              },
              [_vm._v("Automation Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportSpecialPanelTraining,
                  callback: function ($$v) {
                    _vm.$set(
                      _vm.featureForm,
                      "supportSpecialPanelTraining",
                      $$v
                    )
                  },
                  expression: "featureForm.supportSpecialPanelTraining",
                },
              },
              [_vm._v("Special Panel Training")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportConsultancy,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportConsultancy", $$v)
                  },
                  expression: "featureForm.supportConsultancy",
                },
              },
              [_vm._v("Consultancy")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportIntegrationSetup,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportIntegrationSetup", $$v)
                  },
                  expression: "featureForm.supportIntegrationSetup",
                },
              },
              [_vm._v("Integration Setup")]
            ),
            _vm._v(" "),
            _c(
              "a-checkbox",
              {
                model: {
                  value: _vm.featureForm.supportStrategyPlanning,
                  callback: function ($$v) {
                    _vm.$set(_vm.featureForm, "supportStrategyPlanning", $$v)
                  },
                  expression: "featureForm.supportStrategyPlanning",
                },
              },
              [_vm._v("Strategy Planning")]
            ),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }